module.exports = __webpack_public_path__ + "static/assets/5609c9f99dc35d7152239f0a071dab58.svg";